<template>
  <!-- 案件詳細(企業検診) -->
  <div id="RequesKenshintDetail">
    <div id="container" style="width:1400px">
      <div class="labelTitle lable">案件詳細</div>
      <div class="button-area">
        <b-button class="backButton is-primary" v-on:click="back">戻る</b-button>
      </div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table id="requestDetailTable">
            <tr><th>受付番号</th>
              <td colspan="2">{{item.receiptNumber}}
              <b-button v-if="canSalesInfoEdit" style="margin-left:5px; width:150px; float:right" class="is-primary" @click="recordSalesEdit">
                売上情報<template v-if="item.status != requestStatus.completionAppropriation">編集</template>
              </b-button></td>
            </tr>
            <tr><th>種別</th><td colspan="2">{{getKindGroupLabel(item.kind)}} <span v-if="item.demo" class="demo"/></td></tr>
            <tr><th>機種名</th><td colspan="2">{{getKind(item.kind)}}</td></tr>
            <tr><th>依頼元</th><td colspan="2">{{item.client}}<span v-if="item.proxyFlag" class="agent"/></td></tr>
            <tr><th>企業名</th><td colspan="2">{{item.hospital}}</td></tr>
            <tr><th>申込日</th><td colspan="2">{{item.applicationDate}}　{{item.applicationUserName}}</td></tr>
            <tr><th>判定医</th><td colspan="2">{{item.judgmentName}}</td></tr>
            <tr><th>状態</th>
              <td colspan="2">
                <span :class='getTabClass4InternalStatus(item.status)'>{{getStatus(item.status)}}</span>
                <template v-if="canSales">
                  <b-icon  style="margin-top:7px; width:20px;" icon="arrow-right-bold-outline" />
                  <b-button style="margin-left:5px; width:150px;" class="is-primary" @click="showRecordSaleseArea">売上を計上する</b-button>
                </template>
              </td>
            </tr>
            <tr v-if="canSales"><th>売上未連携理由</th><td colspan="2">{{item.apiErrMsg}}</td></tr>

            <template v-if="cancelReason">
              <tr><th>キャンセル理由</th><td colspan="2"><textarea readonly v-model="cancelReason" maxlength="256" style="resize:vertical;width:100%;max-width:100%;height:100px;"></textarea></td></tr>
            </template>
            <template v-if="item.deliveryslipFlag">
              <tr></tr>
              <tr><th>納品書</th>
                <td style="width:800px;">
                  <span v-if="item.deliveryslipFlag" class="caution">納品書の添付が必要な案件です。</span> 
                </td>
                <td><input  v-if="!uploadMode" type="button" style="margin:0 5px;" value="ファイルを追加する" @click="changeUploadMode"/></td>
              </tr>
              <template v-if="uploadMode">
                <tr><th></th>
                  <td>
                    <div class="upload_area uploadArea" @dragenter="dragEnter">
                      ここにファイルをドラッグアンドドロップするか、「ファイルを追加」を押します。
                    </div>
                    <b-modal :active.sync="isUpdateModal" has-modal-card>
                      <div class="modal-card uploadModal" 
                        @dragleave="dragLeave"
                        @drop.prevent="fileDorop"
                      >
                      ここにファイルをドロップします。
                      </div>
                    </b-modal>
                  </td>
                  <td>
                    <b-upload v-model="upButtonFile" style="margin:0 5px;" class="file-label" v-on:input="addUploadfile" multiple>
                      <span class="file-cta">
                        <span class="file-label">ファイルを追加</span>
                      </span>
                    </b-upload>
                  </td>
                </tr>
                <tr><th></th>
                  <td>
                    <div style="margin-top:0px;">
                        <ul>
                            <li v-for="(file ,index) in voucherFiles" class="reportFiles" :key="'vo'+index">
                              <b-icon icon="paperclip"/>{{file.name}}
                            </li>
                            <li v-for="(file ,index) in upFileList" class="reportFiles" :key="'up'+index">
                              <b-icon icon="paperclip"/>{{file.name}} <a @click="removeUploadfile(index)"><b-icon icon="delete-forever-outline"/></a>
                            </li>
                        </ul>
                      </div>
                    </td>
                </tr>
                <tr><th></th>
                  <td style="padding-top: 20px; ">
                    <b-button style="width:150px;" class="is-primary" :disabled="upFileList.length == 0" @click="uploadVoucherFile" >アップロード</b-button>
                    <b-button style="margin-left:5px; width:150px;" class="is-primary" @click="addFileCancel" >キャンセル</b-button>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr><th></th>
                  <td>
                    <div>
                        <ul>
                            <li v-for="(file ,index) in voucherFiles" class="reportFiles" :key="index">
                              <a @click="downloadFile(file.path, file.fileId)" style="text-decoration: underline;"><b-icon icon="paperclip"/>{{file.name}}</a>
                            </li>
                        </ul>
                      </div>
                    </td>
                  <td></td>
                </tr>
              </template>
            </template>
            <template v-if="salesInfo.isNotJudgement && salesInfo.canFileUpCnt > 0">
              <tr></tr>
              <tr>
                <th>アップロードファイル<br>(マクロデータ,PDFファイル)</th>
                <td colspan="2">
                  <input  v-if="!zipUploadMode" type="button" style="float:right;width:17%;" value="ファイルを追加する" @click="changeZipUploadMode"/>
                  <template v-if="zipUploadMode">
                    <div class="upload_area uploadArea" @dragenter="dragEnterZip">
                      ここにファイルをドラッグアンドドロップするか、「ファイルを追加」を押します。
                    </div>
                    <b-modal :active.sync="isZipUpdateModal" has-modal-card>
                      <div class="modal-card uploadModal" 
                        @dragleave="dragLeaveZip"
                        @drop.prevent="zipFileDorop"
                      >
                      ここにファイルをドロップします。
                      </div>
                    </b-modal>
                    <b-upload v-model="upButtonZipFile" class="file-label" v-on:input="addUploadZipfile" multiple>
                      <span class="file-cta">
                        <span class="file-label">ファイルを追加</span>
                      </span>
                    </b-upload>
                    <ul class="upfileList">
                      <li v-for="(file ,index) in zipFiles" :key="'re'+index">
                        <div v-if="file.ctrl" class="fileNameArea line-through" style="width:90%;">
                          <template style="width:60%;"><b-icon icon="paperclip" />{{file.name}}</template>
                          <b-checkbox class="cstmCheckBox deletecheck" style="padding-top:0px;float:right;" v-model="file.ctrl">削除する</b-checkbox>
                        </div>
                        <div v-else class="fileNameArea" style="width:90%;">
                          <template style="width:60%;"><b-icon icon="paperclip" />{{file.name}}</template>
                          <b-checkbox class="cstmCheckBox deletecheck" style="padding-top:0px;float:right;" v-model="file.ctrl">削除する</b-checkbox>
                        </div>
                      </li>
                      <li v-for="(file ,index) in upZipFileList" :key="'up'+index">
                        <b-icon icon="paperclip"/>{{file.name}} <a @click="removeUploadZipfile(index)"><b-icon icon="delete-forever-outline"/></a>
                      </li>
                    </ul>
                    <template>
                      <b-button style="margin-top:10px;width:150px;" class="is-primary" :disabled="uploadImpossible" @click="uploadZipFile" >アップロード</b-button>
                      <b-button style="margin-top:10px;width:150px;" class="is-primary" @click="addZipFileCancel" >キャンセル</b-button>
                    </template>
                  </template>
                  <template v-else>
                    <ul style="width:80%;">
                      <li v-for="(file ,index) in zipFiles" :key="index">
                        <a @click="downloadFile(file.path, file.fileId)" style="text-decoration: underline;"><b-icon icon="paperclip"/>{{file.name}}</a>
                      </li>
                    </ul>
                  </template>
                </td>
              </tr>
            </template>
          </table>
        </div>
        <template v-for="(delivInfo, index) in kenshinRequestDetailList.requestList">
            <div :key="index" class="card-content margin-top">
            <span style="font-size:20px;">配送先情報{{index+1}}</span>
                <table id="officeTable">
                    <tr><th>事業所名</th><td>{{delivInfo.officeName}}</td></tr>
                    <tr><th>装置配送先</th><td>〒{{delivInfo.postcode}}　{{delivInfo.address}}</td></tr>
                    <tr><th>装置配送先宛名</th><td>{{delivInfo.destination}}</td></tr>
                    <template>
                      <tr><th>診断結果送付先</th><td v-if="delivInfo.resultJudgementFlag">〒{{delivInfo.resultPostcode}}　{{delivInfo.resultAddress}}</td><td v-else>〒{{delivInfo.postcode}}　{{delivInfo.address}}</td></tr>
                      <tr><th>診断結果送付先宛名</th><td v-if="delivInfo.resultJudgementFlag">{{delivInfo.resultDestination}}</td><td v-else>{{delivInfo.destination}}</td></tr>
                    </template>
                    <tr/>
                    <template v-if="delivInfo.cancelReason">
                      <tr><th>キャンセル理由</th><td><textarea readonly v-model="delivInfo.cancelReason" maxlength="256" style="resize:vertical;width:100%;max-width:100%;height:100px;"></textarea></td></tr>
                    </template>
                    <tr><th>被験者リスト</th>
                        <td>
                            <table v-if="delivInfo.menberlist.length > 0">
                                <tr>
                                    <th class="th_no">受付番号</th>
                                    <th class="th_name">氏名</th>
                                    <th class="th_name">氏名（カナ）</th>
                                    <th class="th_birth">生年月日</th>
                                    <th class="th_gender">性別</th>
                                    <th class="th_id">社員番号</th>
                                    <th class="th_status">状態</th>
                                    <th class="th_serial">シリアル</th>
                                    <th class="th_progress">進捗</th>
                                </tr>
                                <template v-for="(menber,rowNum) in delivInfo.menberlist">
                                <tr :key=rowNum>
                                    <td>{{menber.receptionBranchNo}}</td>
                                    <td>{{menber.patientName}}</td>
                                    <td>{{menber.patientNameKana}}</td>
                                    <td>{{menber.birthday}}</td>
                                    <td>{{menber.gender}}</td>
                                    <td style="width:120px;word-break:break-all;">{{menber.employeeNo}}</td>
                                    <td>
                                        <span :class='getTabClass4InternalStatus(menber.status)' style="height:24px !important;">{{getStatus(menber.status)}}</span>
                                    </td>
                                    <td style="padding-left:5px;">{{menber.serial}}</td>
                                    <td class="h-center">
                                      <a v-if="menber.history.length > 0" @click="showHistory(menber.history)">
                                        <b-icon icon="chart-line"></b-icon>
                                      </a>
                                    </td>
                                </tr>
                                </template>
                            </table>
                        </td>
                    </tr>
                </table>
            </div>
        </template>
      </div>
      <div class="button-area">
        <b-button class="backButton is-primary" v-on:click="back">戻る</b-button>
      </div>
      <floatingDiv v-if="isShowRecordSales" @close="closeRecordSalesArea" title="" width="580px" height="450px" top="100px" right="300px">
        <recordSales :salesInfo="salesInfo" :type="recordSalesDialogType" :isKenshin="true" @close="closeRecordSalesArea" @recordSales="recordSales"/>
      </floatingDiv>
      <floatingDiv v-if="isShowHistory" @close="closeHistory" title="" width="970px" height="400px" right="100px">
        <historyDetail :statusHistory="history"/>
      </floatingDiv>
    </div>
  </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
import {requestStatus} from "@/components/mock/base/const.js";
import {UploadType} from "@/components/mock/base/const.js";
import floatingDiv from "@/components/mock/common/FloatingDiv";
import RecordSalesDetail from "@/components/mock/common/RecordSalesDetail";
import HistoryDetail from "@/components/mock/common/HistoryDetail";
export default {
  name: "RequesKenshintDetail",
  methods: {
    back: function() {
      this.$router.push({
        name: "RequestSearch",
        params: {searchConditions: this.preSearchCondition}
      });
    },
    getKenshinRequestDetail: async function() {
      let _this = this;
      // Web Api Call
      await this.apiAnsyncCall(
        function(client){
          return client.apis.internalRequestSearch.getKenshinRequestDetailSearchPOST({
            body:{receiptNumber:_this.item.receiptNumber}
          });
        },
        function(result) {
          _this.kenshinRequestDetailList = result.obj;
          _this.salesInfo.requestCount = result.obj.totalRequestCount;
          _this.salesInfo.completeCount = result.obj.completeCount;
          _this.salesInfo.cancelCount = result.obj.cancelCount;   
          _this.salesInfo.isNotJudgement = result.obj.isNotJudgement
          _this.salesInfo.canFileUpCnt = result.obj.canFileUpCnt
          _this.cancelReason = result.obj.cancelReason
        },
        function(result) {
          console.log(result);
        }
      );
    },
    downloadFile: function(fileAddress, fileId){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getDownloadFilePOST({
            body:{
              fileId:fileId,
              fileName:fileAddress
            }
          });
        },
        function(result){
          if(result != null && result.status == 200){
            var downloadUrl = result.obj.downloadUrl;
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.href = downloadUrl;
            let targetFile = fileAddress.toLowerCase();
            if(targetFile.endsWith(".pdf")){
                a.target="_blank"
            }
            a.click();
            a.remove();
          } else if(result != null){
            _this.showErrorMessage(result.message);
          } else {
            _this.showErrorMessage("予期しないエラーが発生しました。");
          }
        },
        function(error){
          // エラーメッセージ表示
          _this.showErrorMessage(error);
        }
      );
    },
    recordSalesEdit: function() {
      if(this.item.status ==  requestStatus.completionAppropriation){
        this.recordSalesDialogType = "view";
      } else {
        this.recordSalesDialogType = "edit";
      }
      this.isShowRecordSales = true;
    },
    showRecordSaleseArea: function() {
      this.recordSalesDialogType = "sales";
      this.isShowRecordSales = true;
      this.item.status = requestStatus.salesAppropriation;
    },
    closeRecordSalesArea: function(){
      if(this.item.status ==  requestStatus.salesAppropriation){
        this.item.status =  this.status;
      }
      this.isShowRecordSales = false;
    },
    recordSales: function() {
      this.item.status =  requestStatus.completionAppropriation;
      this.canSales = false;
      this.closeRecordSalesArea();
    },
    changeUploadMode: function(){
      this.uploadMode = true;
    },
    addFile: function(){
      this.uploadMode = false;
    },
    addFileCancel: function(){
      this.upFileList = [];
      this.uploadMode = false;
    },
    uploadVoucherFile: async function(){
      let targetFile = this.upFileList;
      const nameList = targetFile.map(item => item['path']);
      for(let i = 0; i < nameList.length; i++){
        if(nameList[i].startsWith("/")){
          let zipName = nameList[i].replace("/", "");
          nameList[i] = zipName + ".zip"
        }
      }
      const setElements = new Set(nameList);
      if (setElements.size !== nameList.length) {
        this.showErrorMessage("名前が重複しているファイルが存在します。")
        return
      }
      let okSize = await this.checkUploadFileSize(targetFile);
      if(!okSize){
        this.showErrorMessage("2GBを超えるファイルはアップロードできません。");
        return
      }
      let _this = this
      this.multipleUpload(this.upFileList ,this.item.receiptNumber, this.UploadType.deliveryslip , "").then(result => {
        this.showMessage("登録が完了しました。", 
          async function(){
              await _this.getRequestDetailFiles();
              _this.upFileList = [];
              _this.uploadMode = false;
          });
        }).catch(error =>{
          this.showErrorMessage(error);
      });
    },
    dragEnter: function() {
      this.isUpdateModal = true;
    },
    dragLeave: function() {
      this.isUpdateModal = false;
    },
    fileDorop: function(event) {
      let hasDirectory = false;
      for(let i =0 ; i < event.dataTransfer.items.length; i++){
        const item = event.dataTransfer.items[i];
        const entry = item.webkitGetAsEntry();
        let path = entry.name;
        if(!entry.isDirectory){
          if(!this.upFileList.some(item=>{ return item.name == path;})){
            this.upFileList.push({ file: entry, path: path , name: path});
          }
        } else {
          hasDirectory = true;
        }
      }
      if(hasDirectory){
        this.showMessage("フォルダーは追加できません。"); 
      }
      this.isUpdateModal = false;
    },
    addUploadfile: function(){
      for(let upFile of this.upButtonFile){
        if(!this.upFileList.some(item=>{ return item.name == upFile.name;})){
          this.upFileList.push({ file: upFile, path: upFile.name,name:upFile.name });
        }
      }
      this.upButtonFile = [];
    },
    removeUploadfile: function(index){
      this.upFileList.splice(index,1);
    },
    getRequestDetailFiles: async function() {
      let _this = this;
      // Web Api Call
      this.apiAnsyncCall(
        function(client){
          return client.apis.internalRequestSearch.getRequestDetailFilesPOST({
            body:{receiptNumber:_this.item.receiptNumber}
          });
        },
        function(result) {
          _this.voucherFiles = result.obj.voucherFiles;
          _this.zipFiles = result.obj.zipFiles
        },
        function(result) {
        }
      );
    },
    changeZipUploadMode: function(){
      this.zipUploadMode = true;
    },
    addZipFile: function(){
      this.zipUploadMode = false;
    },
    addZipFileCancel: function(){
      this.upZipFileList = [];
      this.zipUploadMode = false;
    },
    uploadZipFile: async function(){
      let targetFile = this.upZipFileList;
      var nameList = targetFile.map(item => item['path']);
      for(let i = 0; i < nameList.length; i++){
        if(nameList[i].startsWith("/")){
          let zipName = nameList[i].replace("/", "");
          nameList[i] = zipName + ".zip"
        }
      }
      var notDeleteFile = this.zipFiles.filter(val => !val.ctrl);
      var uploadedNameList = notDeleteFile.map(item => item['name']);
      nameList = nameList.concat(uploadedNameList)
      const setElements = new Set(nameList);
      if (setElements.size !== nameList.length) {
        this.showErrorMessage("名前が重複しているファイルが存在します。")
        return
      }
      let okSize = await this.checkUploadFileSize(targetFile);
      if(!okSize){
        this.showErrorMessage("2GBを超えるファイルはアップロードできません。");
        return
      }
      let _this = this
      //まずはファイルのアップロード
      this.multipleUpload(this.upZipFileList ,this.item.receiptNumber, this.UploadType.kenshin_report, "")
      .then(result => {
        var upFileNames = this.upZipFileList.map(item => item['path']);
        var deleteFile = this.zipFiles.filter(val => val.ctrl && val.fileId)
        var delFileId = []
        if (deleteFile.length > 0) {
          deleteFile.forEach(ele => {
            delFileId.push(ele.fileId)
          });
        }
        var reqParam = {
          receiptNumber:this.item.receiptNumber,
          uploadFileList:upFileNames,
          deleteFileList:delFileId
        }
        this.replaceKenshinReportFile(reqParam);
        }).catch(error =>{
          this.showErrorMessage("ファイルアップロードに失敗しました。<br>再度実行してください。");
      });
    },
    replaceKenshinReportFile: function(param) {
      let _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalKenshin.replaceKenshinReportFilePOST({
            body:param
          });
        },
        async function(result){
          await _this.getRequestDetailFiles();
          _this.upZipFileList = [];
          _this.zipUploadMode = false;
          _this.showMessage("登録が完了しました。");
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    dragEnterZip: function() {
      this.isZipUpdateModal = true;
    },
    dragLeaveZip: function() {
      this.isZipUpdateModal = false;
    },
    zipFileDorop: function(event) {
      let hasDirectory = false;
      for(let i =0 ; i < event.dataTransfer.items.length; i++){
        const item = event.dataTransfer.items[i];
        const entry = item.webkitGetAsEntry();
        let path = entry.name;
        if(!entry.isDirectory){
          if(!this.upZipFileList.some(item=>{ return item.name == path;})){
            this.upZipFileList.push({ file: entry, path: path , name: path});
          }
        } else {
          hasDirectory = true;
        }
      }
      if(hasDirectory){
        this.showMessage("フォルダーは追加できません。"); 
      }
      this.isZipUpdateModal = false;
    },
    addUploadZipfile: function(){
      for(let upFile of this.upButtonZipFile){
        if(!this.upZipFileList.some(item=>{ return item.name == upFile.name;})){
          this.upZipFileList.push({ file: upFile, path: upFile.name,name:upFile.name });
        }
      }
      this.upButtonZipFile = [];
    },
    removeUploadZipfile: function(index){
      this.upZipFileList.splice(index,1);
    },
    showHistory: function(history) {
      this.history = history
      this.isShowHistory = true;
    },
    closeHistory: function(){
      this.history = null
      this.isShowHistory = false;
    }
  },
  data() {
    var item = this.$route.params["item"]
    var preSearchCondition = this.$route.params["searchConditions"];    
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var canSalesInfoEdit= ( userInfo.roleId == role.role_admin || userInfo.roleId == role.role_salesOffice)
    var canSales= (  userInfo.roleId == role.role_admin
                 ||  userInfo.roleId == role.role_headOffice 
                 || userInfo.roleId == role.role_headOffice_division
                 || userInfo.roleId == role.role_headOffice_sales
                 || userInfo.roleId == role.role_salesOffice)
                && (item.status == requestStatus.completion || item.status == requestStatus.salesAppropriation) //完了または売上計上中
                && item.demo !=  true
    var salesInfo  = {
        kind: item.type,
        receiptNumber: item.receiptNumber,
        customerCode:  item.customerCode,
        customerName:  item.customerName,
        salesOfficeCode: item.salesOfficeCode,
        salesStaffCode: item.salesStaffCode,
        shippingDate:  "-----------",
        itemCode:  item.itemCode,
        estimateCode:  item.estimateCode,
        patientName:  "-----------",
        hospital: item.hospital,
        inspectionDate: "-----------",
        requestCount: 0,
        completeCount: 0,
        cancelCount: 0,
        canFileUpCnt:0,
        isNotJudgement:false
      };

    return {
      UploadType, 
      preSearchCondition,      
      requestStatus,
      isShowRecordSales:false,
      canSalesInfoEdit: canSalesInfoEdit,
      canSales:canSales,
      recordSalesDialogType: "",
      item:item,
      voucherFiles: [],
      salesInfo: salesInfo,
      uploadMode: false,
      isUpdateModal: false,
      upFileList: [],
      upButtonFile:null,
      kenshinRequestDetailList: [],
      zipUploadMode: false,
      isZipUpdateModal: false,
      zipFiles:[],
      upZipFileList:[],
      upButtonZipFile:null,
      cancelReason: "",
      isShowHistory: false,
      history: [],
      status: item.status,
    };
  },
  computed:{
    uploadImpossible: function(){
      var deleteFile = this.zipFiles.filter(val => val.ctrl)
      if(this.upZipFileList.length == 0 && deleteFile.length == 0){
        return true
      }
      return false
    }
  },
  filters: {},
  components: {
    floatingDiv: floatingDiv,
    recordSales:RecordSalesDetail,
    historyDetail: HistoryDetail,
  },
  mounted: async function() {
    var appVue = this.$root.$children[0];
    appVue.loadingStart();
    await this.getRequestDetailFiles();
    await this.getKenshinRequestDetail();
    appVue.loadingEnd();
  }
};
</script>
<style lang="scss" scoped>
.tag {
  width: 150px !important;
  height: 36px !important;
}
.status {
  width: 150px !important;
  height: 36px !important;
}
.delay {
  color: red;
  font-weight: bold;
}
.th_serial {
    width: 200px !important;
}
.th_no {
    width: 150px !important;
}
.th_name {
    width: 200px !important;
}
.th_birth {
    width: 100px !important;
}
.th_gender {
    width: 50px !important;
}
.th_id {
    width: 100px !important;
}
.th_status,
.th_progress {
    text-align: center;
    width: 80px !important;
}
.caution {
  color: red;
  margin-right:10px;
}
.reportFiles {
  float: left;
  margin-right:10px;
}
.uploadModal {
  width: 900px !important;
  height:500px !important;
  display: grid !important;
  place-items: center !important;
}
#requestDetailTable,#officeTable td {
  word-break: break-all ;
}
.fileNameArea {
  width: 250px;
  word-wrap: break-word;
}
.fileNameArea.line-through {
  text-decoration: line-through;
}
.h-center {
  padding-left: 0 !important;
  text-align: center; 
  margin-left: auto;
  margin-right: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/search/RequesKenshintDetail.vue